
import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Linkedin, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    { name: 'Website Design', path: '/services/website-design' },
    { name: 'Photography', path: '/services/photography' },
    { name: 'Marketing', path: '/services/marketing' },
    { name: 'SEO Services', path: '/services/seo' },
    { name: 'Branding', path: '/services/branding' },
    { name: 'Software', path: '/services/software' },
    { name: 'Real Estate Media', path: '/services/real-estate-media' },
    { name: 'Tech Coaching', path: '/services/tech-coaching' },
    { name: 'Virtual Tours', path: '/services/virtual-tours' },
    { name: 'LED Printing', path: '/services/led-printing' },
  ];

  const company = [
    { name: 'About', path: '/about' },
    { name: 'Portfolio', path: '/portfolio' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' },
  ];

  const socialLinks = [
    { icon: <Instagram size={18} />, url: 'https://instagram.com/astremco', label: 'Instagram' },
    { icon: <Facebook size={18} />, url: 'https://facebook.com/astremco', label: 'Facebook' },
    { icon: <Linkedin size={18} />, url: 'https://www.linkedin.com/company/astrem/', label: 'LinkedIn' },
  ];

  return (
    <footer className="bg-white border-t border-astrem-gray-200">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-12 md:py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company Info */}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <img 
                src="/lovable-uploads/d023512a-50be-4738-9760-d5afcf453819.png" 
                alt="Astrem" 
                className="h-10 w-auto" 
              />
            </Link>
            <p className="text-astrem-gray-600 text-sm leading-relaxed">
              We are a marketing, technology, and creative consulting company based in Baton Rouge, Louisiana. We craft beautiful solutions for businesses, organizations, and individuals.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-astrem-gray-100 text-astrem-gray-700 hover:bg-astrem-black hover:text-white transition-colors duration-300"
                  aria-label={social.label}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-medium text-lg mb-4">Services</h3>
            <ul className="space-y-3">
              {services.map((item, index) => (
                <li key={index}>
                  <Link 
                    to={item.path} 
                    className="text-astrem-gray-600 hover:text-astrem-black transition-colors text-sm"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-medium text-lg mb-4">Company</h3>
            <ul className="space-y-3">
              {company.map((item, index) => (
                <li key={index}>
                  <Link 
                    to={item.path} 
                    className="text-astrem-gray-600 hover:text-astrem-black transition-colors text-sm"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-medium text-lg mb-4">Contact</h3>
            <ul className="space-y-3">
              <li>
                <a 
                  href="tel:225-331-6114" 
                  className="text-astrem-gray-600 hover:text-astrem-black transition-colors text-sm flex items-center"
                >
                  <Phone size={16} className="mr-2" />
                  Phone
                </a>
              </li>
              <li className="text-astrem-gray-600 text-sm">
                Based in Baton Rouge, Louisiana
              </li>
              <li className="text-astrem-gray-600 text-sm">
                Serving clients across the United States
              </li>
            </ul>
          </div>
        </div>

        <div className="py-6 border-t border-astrem-gray-200 flex flex-col md:flex-row items-center justify-between text-sm text-astrem-gray-500">
          <div>© {currentYear} Astrem. All rights reserved.</div>
          <div className="mt-4 md:mt-0 flex space-x-6">
            <Link to="/privacy-policy" className="hover:text-astrem-black transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="hover:text-astrem-black transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
